/* Lumière bracelet configurator. Native Palo Alto forms remain the cart source. */
(function () {
  'use strict';

  if (window.LumiereConfigurator && window.LumiereConfigurator.version === '2.2.0') {
    window.LumiereConfigurator.boot();
    return;
  }

  var previous = window.LumiereConfigurator;
  if (previous && typeof previous.retire === 'function') previous.retire();
  else if (previous && typeof previous.get === 'function') {
    document.querySelectorAll('[data-lumiere-configurator]').forEach(function (root) {
      var instance = previous.get(root);
      if (instance && typeof instance.destroy === 'function') instance.destroy();
    });
  }

  var instances = new Map();
  var retired = false;
  var loaderPromise = null;
  var MAX_MODEL_RETRIES = 3;
  var PROPERTY_NAMES = { symbol: '_Symbol', color: '_Bracelet color' };
  var CANONICAL_LABELS = {
    fairy: 'FATD Scary Hours', rabbit: 'For all the Dogs', bear: 'Graduation Bear', owl: 'OVO Owl', xo: 'XO',
    black: 'Black', white: 'White', palepink: 'Pale pink', fuchsia: 'Fuchsia', lightblue: 'Light blue', red: 'Red', blue: 'Blue',
    green: 'Green', beige: 'Beige', purple: 'Purple', brown: 'Brown', grey: 'Grey', gray: 'Grey'
  };

  function normalize(value) {
    return String(value == null ? '' : value).toLowerCase().replace(/ß/g, 'ss')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]/g, '');
  }

  function aliases(entry) {
    return [entry.id, entry.value, entry.label].concat(entry.aliases || [])
      .filter(function (value) { return value != null && value !== ''; }).map(normalize);
  }

  // Return the exact Shopify value, rather than a translated or normalized value.
  function resolveOptionValue(entry, values) {
    if (!entry) return null;
    if (entry.value != null && String(entry.value).trim() !== '') {
      // Merchant overrides are authoritative. A typo must not choose another SKU.
      return (values || []).find(function (value) { return value === entry.value; }) || null;
    }
    var names = aliases(entry);
    return (values || []).find(function (value) { return names.indexOf(normalize(value)) !== -1; }) || null;
  }

  // Sold-out variants are still an exact match. Availability is checked separately.
  function findVariant(variants, selectedOptions) {
    return (variants || []).find(function (variant) {
      return Array.isArray(variant.options) && variant.options.length === selectedOptions.length &&
        variant.options.every(function (value, index) {
          return selectedOptions[index] != null && value === selectedOptions[index];
        });
    }) || null;
  }

  function findEntry(entries, value) {
    var explicit = (entries || []).find(function (entry) {
      return entry.value != null && String(entry.value).trim() !== '' && entry.value === value;
    });
    if (explicit) return explicit;
    var candidate = normalize(value);
    return (entries || []).find(function (entry) {
      return (entry.value == null || String(entry.value).trim() === '') && aliases(entry).indexOf(candidate) !== -1;
    }) || null;
  }

  function absoluteURL(value) {
    try { return new URL(value, document.baseURI).href; } catch (error) { return value; }
  }

  function loadModelViewer(url) {
    if (window.customElements && customElements.get('model-viewer')) return Promise.resolve();
    if (loaderPromise) return loaderPromise;
    loaderPromise = new Promise(function (resolve, reject) {
      if (!url || !window.customElements) {
        reject(new Error('The 3D viewer is not available.'));
        return;
      }
      var script = document.createElement('script');
      var settled = false;
      var timer = window.setTimeout(function () { finish(new Error('The 3D viewer timed out.')); }, 20000);
      function finish(error) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        script.onload = null;
        script.onerror = null;
        if (error) { script.remove(); reject(error); } else { resolve(); }
      }
      script.type = 'module';
      script.src = url;
      script.dataset.lumiereModelViewerLoader = 'true';
      script.onerror = function () { finish(new Error('The 3D viewer could not be loaded.')); };
      script.onload = function () {
        if (customElements.get('model-viewer')) finish();
        else customElements.whenDefined('model-viewer').then(function () { finish(); });
      };
      document.head.appendChild(script);
    }).catch(function (error) { loaderPromise = null; throw error; });
    return loaderPromise;
  }

  function Configurator(root) {
    this.root = root;
    this.config = JSON.parse(root.dataset.config || '{}');
    this.symbols = this.config.symbols || [];
    this.colors = this.config.colors || [];
    this.variants = this.config.variants || [];
    this.optionNames = this.config.options || [];
    this.strings = this.config.strings || {};
    this.form = document.getElementById(this.config.formId) ||
      (root.closest('.product-single__details') || root.parentElement).querySelector('[data-product-form]');
    this.scope = root.closest('[data-section-id]') || root.closest('.shopify-section') || root.parentElement;
    this.viewer = root.querySelector('[data-lumiere-viewer]');
    this.status = root.querySelector('[data-lumiere-status]');
    this.currentSymbol = root.querySelector('[data-lumiere-current-symbol]');
    this.currentColor = root.querySelector('[data-lumiere-current-color]');
    this.availability = root.querySelector('[data-lumiere-availability]');
    this.loading = root.querySelector('[data-lumiere-loading]');
    this.errorPanel = root.querySelector('[data-lumiere-error]');
    this.listeners = [];
    this.hiddenWrappers = [];
    this.blockedButtons = new Map();
    this.hiddenPayments = new Map();
    this.syncing = false;
    this.destroyed = false;
    this.requestNumber = 0;
    this.modelTimer = null;
    this.nativeRefreshPending = false;
    this.currentModel = '';
    this.currentModelBase = '';
    this.retryURLs = new Map();
    this.retryCounts = new Map();
    this.symbol = this.symbols.find(function (entry) { return entry.id === 'owl'; }) || this.symbols[0];
    this.color = this.colors.find(function (entry) { return entry.id === 'black'; }) || this.colors[0];
    if (!this.symbol || !this.color) throw new Error('Missing bracelet choices.');

    this.mode = this.config.mode || 'auto';
    this.symbolIndex = this.axisIndex(this.config.symbolIndex, this.symbols);
    this.colorIndex = this.axisIndex(this.config.colorIndex, this.colors);
    if (this.symbolIndex === this.colorIndex) this.colorIndex = -1;
    if (this.mode === 'properties') { this.symbolIndex = -1; this.colorIndex = -1; }
    this.defaultOrbit = this.viewer && (this.viewer.getAttribute('camera-orbit') || '0deg 80deg 105%');
    this.defaultTarget = this.viewer && (this.viewer.getAttribute('camera-target') || 'auto auto auto');
    this.defaultFOV = this.viewer && (this.viewer.getAttribute('field-of-view') || '30deg');
    this.readInitialSelection();
    this.bind();
    this.hideReplacedSelectors();
    this.renderControls();
    this.applySelection(true);
    root.dataset.lumiereReady = 'true';
  }

  Configurator.prototype.listen = function (element, name, callback, capture) {
    if (!element) return;
    element.addEventListener(name, callback, !!capture);
    this.listeners.push(function () { element.removeEventListener(name, callback, !!capture); });
  };

  Configurator.prototype.valuesAt = function (index) {
    return Array.from(new Set(this.variants.map(function (variant) { return variant.options[index]; })
      .filter(function (value) { return value != null; })));
  };

  Configurator.prototype.axisIndex = function (value, entries) {
    var index = Number(value);
    if (value == null || value === '' || !Number.isInteger(index) || index < 0 || index >= this.optionNames.length) return -1;
    var values = this.valuesAt(index);
    return entries.some(function (entry) { return resolveOptionValue(entry, values) !== null; }) ? index : -1;
  };

  Configurator.prototype.idInput = function () {
    return this.form && this.form.querySelector('[data-product-select], input[name="id"], select[name="id"]');
  };

  Configurator.prototype.nativeControls = function (index) {
    if (!this.form) return [];
    var name = 'options[' + this.optionNames[index] + ']';
    return Array.from(this.form.querySelectorAll('[data-single-option-selector], [name^="options["]')).filter(function (input) {
      return input.dataset.index === 'option' + (index + 1) || input.name === name;
    });
  };

  Configurator.prototype.nativeOptions = function () {
    var input = this.idInput();
    var id = input && input.value || this.config.selectedVariantId;
    var variant = this.variants.find(function (item) { return String(item.id) === String(id); });
    var options = variant ? variant.options.slice() : new Array(this.optionNames.length).fill(null);
    // A default product has no option inputs, but its single variant remains real.
    if (!variant && this.variants.length === 1) options = this.variants[0].options.slice();
    var self = this;
    this.optionNames.forEach(function (name, index) {
      var control = self.nativeControls(index).find(function (item) {
        return item.type !== 'radio' && item.type !== 'checkbox' || item.checked;
      });
      if (control) options[index] = control.value;
    });
    return options;
  };

  Configurator.prototype.readInitialSelection = function () {
    var options = this.nativeOptions();
    if (this.symbolIndex >= 0) this.symbol = findEntry(this.symbols, options[this.symbolIndex]) || this.symbol;
    if (this.colorIndex >= 0) this.color = findEntry(this.colors, options[this.colorIndex]) || this.color;
  };

  Configurator.prototype.cartState = function () {
    var options = this.nativeOptions();
    var mappingValid = this.mode !== 'variants' || this.symbolIndex >= 0 && this.colorIndex >= 0;
    if (this.symbolIndex >= 0) {
      options[this.symbolIndex] = resolveOptionValue(this.symbol, this.valuesAt(this.symbolIndex));
      mappingValid = mappingValid && options[this.symbolIndex] !== null;
    }
    if (this.colorIndex >= 0) {
      options[this.colorIndex] = resolveOptionValue(this.color, this.valuesAt(this.colorIndex));
      mappingValid = mappingValid && options[this.colorIndex] !== null;
    }
    var variant = mappingValid ? findVariant(this.variants, options) : null;
    return { options: options, variant: variant, available: !!(this.form && variant && variant.available !== false), mappingValid: mappingValid };
  };

  Configurator.prototype.setNativeOptions = function (state, indices) {
    var self = this;
    var changed = [];
    (indices || [this.symbolIndex, this.colorIndex]).filter(function (index) { return index >= 0; }).forEach(function (index) {
      var value = state.options[index];
      if (value === null) return;
      var controls = self.nativeControls(index);
      controls.forEach(function (input) {
        if (input.type === 'radio' || input.type === 'checkbox') {
          var checked = input.value === value;
          if (input.checked !== checked) { input.checked = checked; if (checked) changed.push(input); }
        } else if (input.value !== value) {
          input.value = value;
          changed.push(input);
        }
      });
    });
    // Palo Alto reads every option during this one event, avoiding intermediate SKUs.
    if (changed.length) changed[0].dispatchEvent(new Event('change', { bubbles: true }));
    var idInput = this.idInput();
    if (idInput) {
      var id = state.variant ? String(state.variant.id) : '';
      if (idInput.value !== id) {
        idInput.value = id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  };

  Configurator.prototype.writeProperties = function () {
    if (!this.form) return;
    var self = this;
    [['symbol', this.symbol], ['color', this.color]].forEach(function (pair) {
      var name = PROPERTY_NAMES[pair[0]];
      var input = Array.from(self.form.querySelectorAll('[data-lumiere-property]')).find(function (item) {
        return item.name === 'properties[' + name + ']';
      });
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + name + ']';
        input.dataset.lumiereProperty = 'true';
        self.form.appendChild(input);
      }
      input.value = CANONICAL_LABELS[pair[1].id] || pair[1].id;
    })
  };

  Configurator.prototype.hideReplacedSelectors = function () {
    var self = this;
    [this.symbolIndex, this.colorIndex].filter(function (index) { return index >= 0; }).forEach(function (index) {
      self.nativeControls(index).forEach(function (input) {
        var wrapper = input.closest('[data-selector-wrapper]');
        if (!wrapper || self.hiddenWrappers.some(function (item) { return item.element === wrapper; })) return;
        self.hiddenWrappers.push({ element: wrapper, hidden: wrapper.hidden });
        wrapper.hidden = true;
        wrapper.classList.add('lumiere-configurator__native-hidden');
      });
    });
  };

  Configurator.prototype.renderControls = function () {
    var self = this;
    [['[data-lumiere-symbol]', this.symbol.id], ['[data-lumiere-color]', this.color.id]].forEach(function (group) {
      self.root.querySelectorAll(group[0]).forEach(function (input) {
        input.checked = input.value === group[1];
        var label = input.closest('label');
        if (label) label.classList.toggle('is-active', input.checked);
      });
    });
  };

  Configurator.prototype.updatePurchaseState = function (state) {
    var self = this;
    this.root.dataset.lumiereAvailable = String(state.available);
    this.root.classList.toggle('is-unavailable', !state.available);
    var unavailableText = !state.available && this.form ?
      (this.strings.selectionUnavailable || this.strings.unavailable || 'This combination is unavailable.') : '';
    if (this.currentSymbol) this.currentSymbol.textContent = this.symbol.label;
    if (this.currentColor) this.currentColor.textContent = this.color.label;
    if (this.availability) {
      this.availability.textContent = unavailableText;
      this.availability.hidden = unavailableText === '';
    }
    // Keep existing markup and the live-region parent when separate lines exist.
    if (this.status && !this.currentSymbol && !this.currentColor) {
      var text = this.symbol.label + ' · ' + this.color.label;
      if (unavailableText && !this.availability) text += ' — ' + unavailableText;
      this.status.textContent = text;
    }
    if (!this.form) return;
    this.form.querySelectorAll('[data-add-to-cart]').forEach(function (button) {
      if (!state.available) {
        if (!self.blockedButtons.has(button)) self.blockedButtons.set(button, { disabled: button.disabled, aria: button.getAttribute('aria-disabled') });
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      } else if (self.blockedButtons.has(button)) {
        var original = self.blockedButtons.get(button);
        // The old value may have been Palo Alto's lock for a missing variant.
        // This exact, available variant has now replaced that invalid selection.
        button.disabled = false;
        if (original.aria === null) button.removeAttribute('aria-disabled'); else button.setAttribute('aria-disabled', original.aria);
        self.blockedButtons.delete(button);
      }
    });
    this.form.querySelectorAll('[data-buy-it-now], .shopify-payment-button').forEach(function (payment) {
      if (!state.available) {
        if (!self.hiddenPayments.has(payment)) self.hiddenPayments.set(payment, payment.hidden);
        payment.hidden = true;
      } else if (self.hiddenPayments.has(payment)) {
        payment.hidden = self.hiddenPayments.get(payment);
        self.hiddenPayments.delete(payment);
      }
    });
  };

  Configurator.prototype.applySelection = function (initial) {
    if (this.destroyed || this.syncing) return;
    this.syncing = true;
    var state = this.cartState();
    this.writeProperties();
    this.setNativeOptions(state);
    this.renderControls();
    this.updatePurchaseState(state);
    this.syncing = false;
    this.updateModel(!!initial);
  };

  Configurator.prototype.refreshFromNative = function () {
    if (this.destroyed || this.syncing) return;
    var options = this.nativeOptions();
    if (this.symbolIndex >= 0) this.symbol = findEntry(this.symbols, options[this.symbolIndex]) || this.symbol;
    if (this.colorIndex >= 0) this.color = findEntry(this.colors, options[this.colorIndex]) || this.color;
    this.applySelection(false);
  };

  Configurator.prototype.guardPurchase = function (event) {
    if (event.type === 'click') {
      var path = event.composedPath ? event.composedPath() : [event.target];
      var purchase = path.some(function (element) {
        return element && element.matches && element.matches('[data-add-to-cart], [data-buy-it-now], .shopify-payment-button, button[type="submit"], input[type="submit"]');
      });
      if (!purchase) return;
    }
    var state = this.cartState();
    this.writeProperties();
    this.syncing = true;
    this.setNativeOptions(state);
    this.syncing = false;
    this.updatePurchaseState(state);
    if (!state.available) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.status) {
        this.status.setAttribute('tabindex', '-1');
        this.status.focus({ preventScroll: true });
      }
    }
  };

  Configurator.prototype.bind = function () {
    var self = this;
    this.listen(this.root, 'change', function (event) {
      var input = event.target;
      if (input.matches('[data-lumiere-symbol]')) self.symbol = self.symbols.find(function (entry) { return entry.id === input.value; }) || self.symbol;
      else if (input.matches('[data-lumiere-color]')) self.color = self.colors.find(function (entry) { return entry.id === input.value; }) || self.color;
      else return;
      self.applySelection(false);
    });
    this.listen(this.form, 'click', function (event) { self.guardPurchase(event); }, true);
    this.listen(this.form, 'submit', function (event) { self.guardPurchase(event); }, true);
    this.listen(this.form, 'change', function (event) {
      if (self.syncing || !event.target.matches('[data-single-option-selector], [name^="options["]')) return;
      self.refreshFromNative();
    });
    this.listen(this.scope, 'theme:variant:change', function (event) {
      if (self.syncing || !self.form || !event.target.contains(self.form)) return;
      // Wait until Palo Alto has completed its own button and inventory updates.
      if (self.nativeRefreshPending) return;
      self.nativeRefreshPending = true;
      Promise.resolve().then(function () {
        self.nativeRefreshPending = false;
        if (!self.destroyed) self.updatePurchaseState(self.cartState());
      });
    });
    this.listen(window, 'popstate', function () {
      if (!self.form) return;
      var id = new URL(window.location.href).searchParams.get('variant');
      var variant = self.variants.find(function (item) { return String(item.id) === String(id); });
      if (!variant) return;
      if (self.symbolIndex >= 0) self.symbol = findEntry(self.symbols, variant.options[self.symbolIndex]) || self.symbol;
      if (self.colorIndex >= 0) self.color = findEntry(self.colors, variant.options[self.colorIndex]) || self.color;
      self.syncing = true;
      self.setNativeOptions({ options: variant.options, variant: variant }, self.optionNames.map(function (name, index) { return index; }));
      self.syncing = false;
      self.applySelection(false);
    });
    this.listen(this.root.querySelector('[data-lumiere-retry]'), 'click', function () { self.retryModel(); });
    this.listen(this.root.querySelector('[data-lumiere-reset]'), 'click', function () { self.resetCamera(); });
    this.root.querySelectorAll('[data-lumiere-turn]').forEach(function (button) {
      self.listen(button, 'click', function () { self.turnCamera(Number(button.dataset.lumiereTurn) || 30); });
    });
    this.root.querySelectorAll('[data-lumiere-zoom]').forEach(function (button) {
      self.listen(button, 'click', function () { self.zoomCamera(Number(button.dataset.lumiereZoom) || 1); });
    });
    if (this.viewer) {
      this.bindMotionPreference();
      this.listen(this.viewer, 'load', function (event) {
        var loadedURL = event.detail && event.detail.url;
        if (loadedURL && absoluteURL(loadedURL) !== absoluteURL(self.currentModel)) return;
        if (absoluteURL(self.viewer.getAttribute('src')) !== absoluteURL(self.currentModel)) return;
        self.recolorCord();
        self.setViewerState('ready');
      });
      this.listen(this.viewer, 'error', function (event) {
        var errorURL = event.detail && event.detail.sourceEvent && event.detail.sourceEvent.target && event.detail.sourceEvent.target.src;
        if (errorURL && absoluteURL(errorURL) !== absoluteURL(self.currentModel)) return;
        self.setViewerState('error');
      });
    }
  };

  Configurator.prototype.bindMotionPreference = function () {
    var self = this;
    // model-viewer pauses its turntable during interaction, then resumes after
    // auto-rotate-delay. Its damping preserves smooth manual drag and pinch.
    if (!this.viewer.hasAttribute('rotation-per-second')) this.viewer.setAttribute('rotation-per-second', '4deg');
    if (!this.viewer.hasAttribute('auto-rotate-delay')) this.viewer.setAttribute('auto-rotate-delay', '4000');
    var query = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    function syncMotionPreference() {
      if (!self.destroyed) self.viewer.toggleAttribute('auto-rotate', !query || !query.matches);
    }
    syncMotionPreference();
    if (query && query.addEventListener) this.listen(query, 'change', syncMotionPreference);
    else if (query && query.addListener) {
      query.addListener(syncMotionPreference);
      this.listeners.push(function () { query.removeListener(syncMotionPreference); });
    }
  };

  Configurator.prototype.setViewerState = function (state) {
    if (this.destroyed) return;
    this.root.dataset.lumiereViewerState = state;
    this.root.classList.toggle('is-loading', state === 'loading');
    this.root.classList.toggle('has-error', state === 'error');
    if (this.loading) this.loading.hidden = state !== 'loading';
    if (this.errorPanel) this.errorPanel.hidden = state !== 'error';
    var retriesExhausted = (this.retryCounts.get(this.currentModelBase) || 0) >= MAX_MODEL_RETRIES;
    var retryButton = this.root.querySelector('[data-lumiere-retry]');
    if (retryButton) retryButton.disabled = retriesExhausted;
    if (state === 'error' && this.errorPanel) {
      var message = this.errorPanel.querySelector('p');
      if (message && this.strings.error) {
        message.textContent = this.strings.error + (retriesExhausted ?
          (String(this.config.locale).indexOf('en') === 0 ? ' Reload the page to try again.' : ' Lade die Seite neu, um es erneut zu versuchen.') : '');
      }
    }
    if (this.viewer) this.viewer.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
    if (state !== 'loading') { window.clearTimeout(this.modelTimer); this.modelTimer = null; }
  };

  Configurator.prototype.retryModel = function () {
    var base = this.symbol.model;
    if (!base) return;
    var count = this.retryCounts.get(base) || 0;
    if (count >= MAX_MODEL_RETRIES) { this.setViewerState('error'); return; }
    var url;
    try {
      url = new URL(base, document.baseURI || window.location.href);
      // A failed GLTF promise is cached by model-viewer. A fresh, bounded URL
      // retries the download while preserving Shopify's existing asset version.
      url.searchParams.set('lumiere_retry', String(count + 1));
    } catch (error) { this.setViewerState('error'); return; }
    this.retryCounts.set(base, count + 1);
    this.retryURLs.set(base, url.href);
    this.updateModel(true);
  };

  Configurator.prototype.updateModel = function (force) {
    if (!this.viewer) return;
    var self = this;
    var base = this.symbol.model;
    var model = this.retryURLs.get(base) || base;
    this.viewer.setAttribute('alt', (this.strings.selectionLabel || 'Bracelet preview') + ': ' + this.symbol.label + ', ' + this.color.label);
    if (!model) { this.setViewerState('error'); return; }
    if (!force && this.currentModel === model) { this.recolorCord(); return; }
    this.currentModelBase = base;
    this.currentModel = model;
    var request = ++this.requestNumber;
    var poster = this.symbol.poster || this.symbol.thumbnail;
    if (poster) this.viewer.setAttribute('poster', poster); else this.viewer.removeAttribute('poster');
    window.clearTimeout(this.modelTimer);
    this.setViewerState('loading');
    this.modelTimer = window.setTimeout(function () {
      if (request === self.requestNumber) self.setViewerState('error');
    }, 30000);
    loadModelViewer(this.config.loaderUrl).then(async function () {
      if (self.destroyed || request !== self.requestNumber) return;
      var alreadyLoaded = self.viewer.loaded && absoluteURL(self.viewer.getAttribute('src')) === absoluteURL(model);
      // Removing src on retry asks model-viewer to retry a previously failed request.
      if (force && self.viewer.getAttribute('src') === model && !self.viewer.loaded) {
        self.viewer.removeAttribute('src');
        // model-viewer is a Lit element: A -> empty -> A must span update cycles.
        await (self.viewer.updateComplete || new Promise(function (resolve) { window.setTimeout(resolve, 0); }));
        if (self.destroyed || request !== self.requestNumber) return;
      }
      self.viewer.setAttribute('src', model);
      if (alreadyLoaded) {
        self.recolorCord();
        self.setViewerState('ready');
      }
    }).catch(function () {
      if (!self.destroyed && request === self.requestNumber) self.setViewerState('error');
    });
  };

  Configurator.prototype.recolorCord = function () {
    var viewer = this.viewer;
    if (!viewer || !viewer.model || !viewer.model.materials) return;
    var cord = viewer.model.materials.find(function (material) { return material.name === 'Lumiere_Cord'; });
    if (cord && cord.pbrMetallicRoughness && cord.pbrMetallicRoughness.setBaseColorFactor) {
      cord.pbrMetallicRoughness.setBaseColorFactor(this.color.hex);
    }
  };

  Configurator.prototype.jumpIfReducedMotion = function () {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches && this.viewer.jumpToGoal) this.viewer.jumpToGoal();
  };

  Configurator.prototype.turnCamera = function (degrees) {
    if (!this.viewer || !this.viewer.getCameraOrbit) return;
    var orbit = this.viewer.getCameraOrbit();
    this.viewer.setAttribute('camera-orbit', (orbit.theta * 180 / Math.PI + degrees) + 'deg ' + orbit.phi + 'rad ' + orbit.radius + 'm');
    this.jumpIfReducedMotion();
  };

  Configurator.prototype.zoomCamera = function (direction) {
    if (!this.viewer || !this.viewer.getCameraOrbit) return;
    var orbit = this.viewer.getCameraOrbit();
    var radius = orbit.radius * (direction > 0 ? 0.85 : 1.18);
    this.viewer.setAttribute('camera-orbit', orbit.theta + 'rad ' + orbit.phi + 'rad ' + radius + 'm');
    this.jumpIfReducedMotion();
  };

  Configurator.prototype.resetCamera = function () {
    if (!this.viewer) return;
    this.viewer.setAttribute('camera-orbit', this.defaultOrbit);
    this.viewer.setAttribute('camera-target', this.defaultTarget);
    this.viewer.setAttribute('field-of-view', this.defaultFOV);
    this.jumpIfReducedMotion();
  };

  Configurator.prototype.destroy = function () {
    this.destroyed = true;
    this.requestNumber++;
    window.clearTimeout(this.modelTimer);
    if (this.viewer) this.viewer.removeAttribute('auto-rotate');
    this.listeners.forEach(function (remove) { remove(); });
    this.hiddenWrappers.forEach(function (item) {
      item.element.hidden = item.hidden;
      item.element.classList.remove('lumiere-configurator__native-hidden');
    });
    this.blockedButtons.forEach(function (original, button) {
      button.disabled = original.disabled;
      if (original.aria === null) button.removeAttribute('aria-disabled'); else button.setAttribute('aria-disabled', original.aria);
    });
    this.hiddenPayments.forEach(function (hidden, payment) { payment.hidden = hidden; });
    delete this.root.dataset.lumiereReady;
    instances.delete(this.root);
  };

  function init(root) {
    if (instances.has(root)) return instances.get(root);
    try {
      var instance = new Configurator(root);
      instances.set(root, instance);
      return instance;
    } catch (error) {
      root.dataset.lumiereReady = 'error';
      var panel = root.querySelector('[data-lumiere-error]');
      var loading = root.querySelector('[data-lumiere-loading]');
      if (panel) panel.hidden = false;
      if (loading) loading.hidden = true;
      console.error('Lumière configurator could not initialize:', error);
      return null;
    }
  }

  function boot(scope) {
    if (retired) return;
    var container = scope && scope.querySelectorAll ? scope : document;
    if (container.matches && container.matches('[data-lumiere-configurator]')) init(container);
    container.querySelectorAll('[data-lumiere-configurator]').forEach(init);
    instances.forEach(function (instance, root) { if (!root.isConnected) instance.destroy(); });
  }

  function onDOMContentLoaded() { boot(); }
  function onSectionLoad(event) { boot(event.target); }
  function onSectionUnload(event) {
    instances.forEach(function (instance, root) { if (event.target.contains(root)) instance.destroy(); });
  }

  function retire() {
    retired = true;
    document.removeEventListener('DOMContentLoaded', onDOMContentLoaded);
    document.removeEventListener('shopify:section:load', onSectionLoad);
    document.removeEventListener('shopify:section:unload', onSectionUnload);
    instances.forEach(function (instance) { instance.destroy(); });
  }

  window.LumiereConfigurator = {
    version: '2.2.0', normalize: normalize, resolveOptionValue: resolveOptionValue,
    findVariant: findVariant, init: init, boot: boot, retire: retire,
    get: function (root) { return instances.get(root); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onDOMContentLoaded);
  else boot();
  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);
})();
